import { createFileRoute } from '@tanstack/react-router'

import CreateBPPPage from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/containers/CreatePage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kecamatan/create'
)({
  component: CreateBPPPage
})
